import { Component, Input, OnInit } from '@angular/core';
import { MatDialogClose } from '@angular/material/dialog';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  imports: [MatDialogClose, FaIconComponent]
})
export class ModalComponent implements OnInit {
  @Input() subtitle: string;
  @Input() title: string;

  ngOnInit() {}
}
